import DOMPurify from 'dompurify';

const profile = {
  FORCE_BODY: true,
  ALLOWED_TAGS: [
    'a',
    'b',
    'br',
    'caption',
    'clippath',
    'col',
    'colgroup',
    'comment-start',
    'comment-end',
    'defs',
    'div',
    'ellipse',
    'g',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'i',
    'img',
    'image',
    'li',
    'mark',
    'marker',
    'ol',
    'rect',
    'p',
    'pattern',
    'path',
    'span',
    'strong',
    'sup',
    'sub',
    'symbol',
    'svg',
    'table',
    'thead',
    'tfoot',
    'tbody',
    'td',
    'text',
    'th',
    'tr',
    'tspan',
    'u',
    'ul',
    'use',
    'style',
    'lineargradient',
    'stop',
    's',
    'figure',
  ],
  ALLOWED_ATTR: [
    'aria-label',
    'src',
    'border',
    'target',
    'cellpadding',
    'cellspacing',
    'class',
    'clip-path',
    'colspan',
    'contenteditable',
    'cx',
    'd',
    'data-cke-filler',
    'data-comment-end-after',
    'data-comment-end-before',
    'data-comment-start-after',
    'data-comment-start-before',
    'data-placeholder',
    'dir',
    'fill',
    'fill-opacity',
    'font-family',
    'font-size',
    'font-stretch',
    'font-style',
    'font-weight',
    'height',
    'href',
    'id',
    'lang',
    'marker-end',
    'marker-start',
    'markerHeight',
    'markerUnits',
    'markerWidth',
    'name',
    'orient',
    'patternunits',
    'preserveaspectratio',
    'role',
    'rowspan',
    'rx',
    'ry',
    'sizes',
    'src',
    'srcset',
    'span',
    'start',
    'stroke',
    'stroke-dasharray',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-opacity',
    'stroke-width',
    'style',
    'text-rendering',
    'text-decoration',
    'transform',
    'version',
    'viewbox',
    'width',
    'x',
    'xlink:href',
    'xml:space',
    'xmlns',
    'xmlns:xlink',
    'y',
    'x1',
    'y1',
    'x2',
    'y2',
    'spreadmethod',
    'gradientunits',
    'stop-color',
    'stop-opacity',
    'offset',
  ],
};

export const sanitize = (input) => {
  const value = DOMPurify.sanitize(input, profile);
  return value;
};
